import {
  ref,
} from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'
import router from '@/router'
import useDriverUserReviews from '@/views/driver-user-shared/driver-user-reviews/hooks/useDriverUserReviews'

export default function useDriverView(props, ctx) {
  const driverExternalId = router.currentRoute.query.externalId
  const driverId = router.currentRoute.params.id
  if (driverExternalId && driverId) {
    const { rating, reviews, fetchReviews } = useDriverUserReviews('drivers', driverExternalId, ctx)
    const toast = useToast()
    const tabIndex = ref(0)
    // if (ctx.root.$route.query['active-tab'] === 'wallet') {
    //   tabIndex.value = 2
    // } else if (ctx.root.$route.query['active-tab'] === 'violations') {
    //   tabIndex.value = 9
    // } else {
    //   tabIndex.value = 0
    // }

    const loadingDriverData = ref(false)
    const driverData = ref(null)
    const fetchDriverInfo = async () => {
      try {
        driverData.value = null
        loadingDriverData.value = true
        const driverInfo = await store.dispatch('drivers/fetchDriver', { id: router.currentRoute.params.id })
        driverData.value = driverInfo.data.data
      } catch (err) {
        const statusCode = err?.response?.status
        if (statusCode === 404 || statusCode === 500) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Driver Not Found',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          router.push('/drivers')
        }
      } finally {
        loadingDriverData.value = false
      }
    }

    const loadingInactivationList = ref(false)
    const fetchDriverInactivations = async () => {
      try {
        loadingInactivationList.value = true

        await store.dispatch('driverView/fetchDriverInactivationList', {
          id: router.currentRoute.params.id,
          isResolvedInactivation: true,
        })

        await store.dispatch('driverView/fetchDriverInactivationList', {
          id: router.currentRoute.params.id,
          isResolvedInactivation: false,
        })
        await fetchDriverInfo()
      } catch (err) {
        console.log(err)
      } finally {
        loadingInactivationList.value = false
      }
    }

    const loadingDriverWallet = ref(false)
    const driverWallet = ref(null)

    const fetchDriverWallet = async () => {
      try {
        driverWallet.value = null
        loadingDriverWallet.value = true
        store.commit('driverView/SET_WALLET_ID', null)
        const driverWalletInfo = await store.dispatch('driverView/fetchDriverWallet', { id: router.currentRoute.params.id })
        driverWallet.value = driverWalletInfo
        store.commit('driverView/SET_WALLET_ID', driverWallet.value.id)
        loadingDriverWallet.value = false
        if (ctx.root.$can('read', 'driver-wallet-transactions')) {
          await store.dispatch('driverView/fetchDriverTransactions')
          await store.dispatch('driverView/fetchDriverPendingTransactions')
          await store.dispatch('transactionTypes/fetchTransactionTypes')
        }
      } catch (err) {
        console.log(err)
      } finally {
        loadingDriverWallet.value = false
      }
    }
    fetchDriverInfo()
    fetchDriverInactivations()
    fetchDriverWallet()

    return {
      driverData,
      driverWallet,
      loadingDriverData,
      loadingInactivationList,
      loadingDriverWallet,
      tabIndex,
      fetchDriverInfo,
      fetchDriverInactivations,
      fetchDriverWallet,
      rating,
      reviews,
      driverExternalId,
      driverId,
      fetchReviews,
    }
  }
  // if no id or external id provided
  return router.push('/drivers')
}
